import { B2B_CHECKOUT_PAGE_KEY } from '../constants';

const locales = {
  [B2B_CHECKOUT_PAGE_KEY]: {
    NAME_LABEL: 'Name',
    REQUIRED_FIELD: 'Required field',
    REQUIRED_NAME: 'Name required',
    INVALID_NAME: 'Invalid name',
    LAST_NAME_LABEL: 'Last Name',
    REQUIRED_LAST_NAME: 'Last name required',
    INVALID_LAST_NAME: 'Invalid last name',

    // Payment errors
    INSUFFICIENT_FUNDS:
      'Our system indicates that you have insufficient funds.',
    EXPIRED_CARD: 'Your card has expired. Please contact your bank.',
    INVALID_INFO_CARD: 'Your card information is incorrect. Please try again.',
    INVALID_CARD: 'Your card is invalid. Please try again.',
    CATCH_MESSAGE: 'Payment could not be processed! Please try again.',
  },
};

export default locales;
